import type { SortDirection } from './searchTypes'
import type { FrontendSiteMarketplaceConfig } from './sites/sitesFrontendTypes'

export interface Language {
  id: number
  en_title: string
  local_title: string
  iso_code: string
  is_english: number
  pivot: {
    gtm_id: string | null
    hotjar_id: string | null
    pixel_id: string | null
    live_agent_id: string | null
    facebook_url: string | null
    instagram_url: string | null
    linkedin_url: string | null
    mp_default_sort: SortDirection
  }
}

export interface Site {
  cdn_bg: string
  cdn_icon: string
  cdn_instructions_desktop: { 1: string; 2: string; 19: string }
  cdn_instructions_mobile: { 1: string; 2: string; 19: string }
  cdn_logo: string
  default_expiration_hours: 24
  facebook_app_client_id: string
  facebook_app_client_secret: string
  klaviyo_key: string | null
  criteo_key: string | null
  languages: Language[]
  name: string
  url: string
  price_group_id: number
  region_iso_code: string | null
  forward_request_config: ForwardRequestConfig
  disabled_additional_fields_per_site: number[]
  marketplace_config: FrontendSiteMarketplaceConfig
}

export interface QueryKeys {
  categoryDocKey: string
  countryId: number
  flagDocKey: string
  itemsDocKey: string
  itemsSugKey: string
  languageId: number
  'itemsDocKey:Collapsed'?: string
}

export interface Currency {
  created_at: string
  deleted_at: string
  en_name: string
  exchange_rate: number
  foreign_name: string
  formatting: string
  id: number
  sales_channel_id: number
  type: number
  updated_at: string
  iso_code: CurrencyCode
}

export enum CurrencyCode {
  Eur = 'EUR',
  Usd = 'USD',
}

export interface Destination {
  created_at: string
  deleted_at: string
  en_name: string
  exchange_rate: number
  foreign_name: string
  formatting: string
  id: number
  sales_channel_id: number
  type: number
  updated_at: string
  iso_code: CurrencyCode
}

export interface ForwardRequestConfig {
  preliminary_customs_fee_percentage: number
  total_declared_value_min_amount: number
  customs_brokerage_fee: number
  invoice_removal_quantity: number
  invoice_removal_price_stable: number
  invoice_removal_price_over_quantity: number
  price_tag_removal_quantity: number
  price_tag_removal_price_stable: number
  price_tag_removal_price_over_quantity: number
  inspect_package_price: number
  return_to_sender_price: number
  abandon_package_price: number
  request_advanced_photos_price: number
  storage_fee_per_day: number
  storage_free_days_count: number
  total_loss_insurance_fee_percentage: number
  consolidation_quantity: number
  consolidation_price_stable: number
  consolidation_price_over_quantity: number
}
